<div class="value">
    <span #num>{{ min }}</span>
    <span>{{ sufix }}</span>
</div>
<input #input #range [id]="id" type="range" (focus)="onFocus(true, $event)" (focusout)="onFocus(false, $event)" />